<script setup lang="ts">
import { useField } from 'vee-validate'
import { useI18n } from 'vue-i18n'

export interface LokalityProps {
  name: string
  poradie: number
  id: string
}

const props = defineProps<LokalityProps>()
const { t } = useI18n()

const { errors } = useField(`${props.name}.nazov`)
</script>

<template>
  <div v-if="props.name" class="locality">
    <IDSKHeading as="h2" variant="m">
      {{ t('zoppm.step6.miesto') }}{{ props.poradie + 1 }}
    </IDSKHeading>
    <ValidationWrapper
      v-slot="slotProps"
      :name="`${props.name}.poradie`"
      :value="props.poradie"
    >
      <IDSKInput :id="`${props.name}.poradie`" v-bind="slotProps" readonly hidden />
    </ValidationWrapper>
    <ValidationWrapper v-slot="slotProps" :name="`${props.name}.rola`">
      <IDSKInput :id="`${props.name}.rola`" v-bind="slotProps" readonly hidden />
    </ValidationWrapper>
    <ValidationWrapper v-slot="slotProps" :name="`${props.name}.nazov`">
      <IDSKInput
        v-bind="slotProps"
        :id="`${props.name}.nazov`"
        :label="t('zoppm.step6.nazovAktivity')"
      />
    </ValidationWrapper>

    <BillingForm :name="props.name" />

    <ValidationWrapper v-slot="slotProps" :name="`${props.name}.katastralneUzemie.kod`">
      <IDSKInput
        v-bind="slotProps"
        :id="`${props.name}.katastralneUzemie.kod`"
        :label="t('zoppm.step6.katastralneUzemieKod')"
      />
    </ValidationWrapper>
    <ValidationWrapper v-slot="slotProps" :name="`${props.name}.katastralneUzemie.nazov`">
      <IDSKInput
        v-bind="slotProps"
        :id="`${props.name}.katastralneUzemie.nazov`"
        :label="t('zoppm.step6.katastralneUzemieNazov')"
      />
    </ValidationWrapper>

    <ValidationWrapper v-slot="slotProps" :name="`${props.name}.parcelneCislo`">
      <IDSKInput
        v-bind="slotProps"
        :id="`${props.name}.parcelneCislo`"
        :label="t('zoppm.step6.parcelneCislo')"
        :hint="t('zoppm.step6.parcelneCisloHint')"
      />
    </ValidationWrapper>
  </div>
</template>

<style lang="scss"></style>
